import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "slive sui-card sui-card--flush" }
const _hoisted_2 = { class: "sui-card__head no-print" }
const _hoisted_3 = { class: "sui-card__title" }
const _hoisted_4 = {
  class: "slive__tabs",
  "data-tour": "seller-orders-tabs"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "sui-toolbar slive__toolbar no-print",
  "data-tour": "seller-orders-toolbar"
}
const _hoisted_10 = { class: "slive__presets" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "sui-field slive__date" }
const _hoisted_13 = { class: "sui-field slive__date" }
const _hoisted_14 = { class: "sui-search" }
const _hoisted_15 = {
  class: "slive__direct-alert no-print",
  "data-tour": "seller-orders-direct"
}
const _hoisted_16 = {
  key: 0,
  class: "slive__error no-print"
}
const _hoisted_17 = {
  key: 1,
  class: "slive__bulk no-print",
  "data-tour": "seller-orders-bulk"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 2,
  class: "slive__picking print-only"
}
const _hoisted_22 = {
  key: 3,
  class: "sui-table-wrap no-print",
  "data-tour": "seller-orders-table"
}
const _hoisted_23 = { class: "sui-table" }
const _hoisted_24 = { class: "is-center slive__check-col" }
const _hoisted_25 = ["checked", ".indeterminate"]
const _hoisted_26 = { class: "is-center slive__check-col" }
const _hoisted_27 = ["checked", "aria-label", "onChange"]
const _hoisted_28 = { class: "sui-table__strong" }
const _hoisted_29 = { class: "sui-table__sub" }
const _hoisted_30 = {
  key: 0,
  class: "slive__focus-tag"
}
const _hoisted_31 = { class: "sui-prod" }
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = { class: "sui-prod__name" }
const _hoisted_34 = {
  key: 0,
  class: "sui-table__sub"
}
const _hoisted_35 = { class: "sui-table__strong" }
const _hoisted_36 = { class: "sui-table__sub" }
const _hoisted_37 = { class: "slive__addr" }
const _hoisted_38 = {
  key: 0,
  class: "slive__memo"
}
const _hoisted_39 = { class: "is-num" }
const _hoisted_40 = { class: "sui-table__strong" }
const _hoisted_41 = { class: "sui-table__sub" }
const _hoisted_42 = { class: "is-num" }
const _hoisted_43 = { class: "sui-table__strong slive__settle" }
const _hoisted_44 = { class: "sui-table__sub" }
const _hoisted_45 = { class: "is-center" }
const _hoisted_46 = { class: "slive__actions" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 1,
  class: "slive__action-hint"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 6,
  class: "slive__done"
}
const _hoisted_54 = {
  key: 7,
  class: "slive__done"
}
const _hoisted_55 = {
  key: 4,
  class: "sui-empty no-print"
}
const _hoisted_56 = { class: "slive__dialog" }
const _hoisted_57 = { class: "slive__dialog-sub" }
const _hoisted_58 = { class: "sui-field" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "sui-field" }
const _hoisted_61 = { class: "slive__dialog-note" }
const _hoisted_62 = { class: "slive__dialog-actions" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "slive__dialog" }
const _hoisted_65 = { class: "slive__dialog-sub" }
const _hoisted_66 = { class: "sui-field" }
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "sui-field" }
const _hoisted_69 = { class: "sui-field" }
const _hoisted_70 = ["max"]
const _hoisted_71 = { class: "sui-field" }
const _hoisted_72 = { class: "slive__dialog-actions" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "slive__dialog slive__dialog--wide" }
const _hoisted_75 = { class: "slive__dialog-sub" }
const _hoisted_76 = { class: "sui-field" }
const _hoisted_77 = ["value"]
const _hoisted_78 = { class: "sui-field" }
const _hoisted_79 = { class: "slive__bulk-ship-list" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = { class: "slive__dialog-actions" }
const _hoisted_82 = ["disabled"]

import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import MallShipmentLedger from '@/components/mall/MallShipmentLedger.vue'
import MallTrackingModal from '@/components/mall/MallTrackingModal.vue'
import { confirmDialog } from '@/composables/useConfirmDialog'
import { useListDateRange } from '@/composables/useListDateRange'
import { useSellerData } from '@/composables/useSellerData'
import { MALL_COURIERS as COURIERS, isKnownMallCourier } from '@/constants/mallCouriers'
import { formatWon } from '@/constants/sellerData'
import {
  MALL_ORDER_ITEM_STATUS_LABEL,
  fetchSellerOrders,
  updateSellerOrderStatus,
  createSellerExtraShipment,
  type ItemStatusCounts,
  type MallOrderItemStatus,
  mallPayMethodLabel,
  type SellerOrderItem,
} from '@/api/mallOrder'
import { csvEscape } from '@/utils/csv'
import { isExistingWaybill, type ShipmentLedgerRow } from '@/utils/mallShipment'
import { autoConfirmLabel } from '@/utils/mallOpsUx'

const LAST_COURIER_KEY = 'hamuri.seller.lastCourier'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerLiveOrders',
  setup(__props) {

function loadLastCourier(): string {
  try {
    const raw = localStorage.getItem(LAST_COURIER_KEY)
    if (raw && isKnownMallCourier(raw)) return raw
  } catch {
    /* ignore */
  }
  return COURIERS[0]
}

function saveLastCourier(name: string) {
  try {
    localStorage.setItem(LAST_COURIER_KEY, name)
  } catch {
    /* ignore */
  }
}

const STATUS_TONE: Record<MallOrderItemStatus, string> = {
  WAITING: 'sui-badge--gray',
  PAID: 'sui-badge--blue',
  READY: 'sui-badge--violet',
  SHIPPING: 'sui-badge--violet',
  DELIVERED: 'sui-badge--green',
  DONE: 'sui-badge--green',
  CANCEL_REQUEST: 'sui-badge--amber',
  RETURN_REQUEST: 'sui-badge--amber',
  CANCELED: 'sui-badge--red',
}

const { notify } = useSellerData()
const route = useRoute()
const router = useRouter()
const { fromDate, toDate, preset, presets, applyPreset, onManualDateChange, inRange } =
  useListDateRange('3m')

/*
 * 알림·리뷰·문의 화면에서 주문번호로 넘어오면(예: /seller/orders?keyword=MO-XXXX) 기본 3개월
 * 필터에 걸려 화면이 비어 보이는 것을 막는다.
 */
if (String(route.query.keyword ?? '').trim()) {
  applyPreset('all')
}

const items = ref<SellerOrderItem[]>([])
const counts = ref<ItemStatusCounts>({})
const loading = ref(false)
const errorMessage = ref('')
const working = ref(false)
const trackTarget = ref<{
  idx: number
  courier?: string
  invoice?: string
  name?: string
  orderCode?: string
} | null>(null)
const filter = ref<'all' | MallOrderItemStatus>('all')

function openTracking(item: SellerOrderItem) {
  trackTarget.value = item
}

function openItemShipment(item: SellerOrderItem, row: ShipmentLedgerRow) {
  trackTarget.value = {
    idx: item.idx,
    courier: row.courier,
    invoice: row.invoice,
    name: item.name,
    orderCode: item.orderCode,
  }
}

function isDirectCourierName(courier: string) {
  return /직접/.test(courier || '')
}

function isDirectShip(item: SellerOrderItem) {
  return isDirectCourierName(item.courier || '')
}

/** 주문 확인(READY) 이후에만 송장·발송. 신규(PAID)는 확인부터 한다. */
function canWriteInvoice(item: SellerOrderItem) {
  return (
    item.status === 'READY' ||
    item.status === 'SHIPPING' ||
    item.status === 'DELIVERED' ||
    item.status === 'DONE'
  )
}

function isNewShip(item: SellerOrderItem) {
  return item.status === 'READY'
}

function shipActionLabel(item: SellerOrderItem) {
  if (isNewShip(item)) return '발송 처리'
  if (item.invoice) return '수정'
  return '송장 입력'
}

function shipDialogTitle(item: SellerOrderItem | null) {
  if (!item) return '송장 입력'
  if (isNewShip(item)) return '발송 처리'
  if (item.invoice) return '송장 수정'
  return '송장 입력'
}

function canExtraShip(item: SellerOrderItem) {
  return item.status === 'SHIPPING' || item.status === 'DELIVERED' || item.status === 'DONE'
}

function isKeywordFocus(item: SellerOrderItem) {
  const query = keyword.value.trim().toLowerCase()
  if (!query) return false
  return item.orderCode.toLowerCase() === query
}

function onCloseTracking() {
  trackTarget.value = null
  void load()
}
const selectedIds = ref<number[]>([])
const keyword = ref(String(route.query.keyword ?? '').trim())

const shipTarget = ref<SellerOrderItem | null>(null)
const shipForm = reactive({ courier: loadLastCourier(), invoice: '' })

const extraShipTarget = ref<SellerOrderItem | null>(null)
const extraShipForm = reactive({
  courier: loadLastCourier(),
  invoice: '',
  qty: 1,
  memo: '오발송·누락 재발송',
})

const bulkShipOpen = ref(false)
const bulkCourier = ref(loadLastCourier())
const bulkInvoices = reactive<Record<number, string>>({})
const bulkShipRows = ref<SellerOrderItem[]>([])
const bulkPasteText = ref('')

const FILTER_KEYS = new Set<MallOrderItemStatus>([
  'PAID',
  'READY',
  'SHIPPING',
  'DELIVERED',
  'DONE',
  'CANCELED',
  'CANCEL_REQUEST',
])

const todayLabel = new Intl.DateTimeFormat('ko-KR', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}).format(new Date())

function parseStatusQuery(raw: unknown): 'all' | MallOrderItemStatus {
  const value = String(raw ?? '')
    .trim()
    .toUpperCase()
  if (!value || value === 'ALL') return 'all'
  if (FILTER_KEYS.has(value as MallOrderItemStatus)) {
    return value as MallOrderItemStatus
  }
  return 'all'
}

function applyStatusQuery() {
  filter.value = parseStatusQuery(route.query.status)
}

async function load() {
  loading.value = true
  errorMessage.value = ''

  try {
    const result = await fetchSellerOrders()
    items.value = result.items
    counts.value = result.counts
    const alive = new Set(result.items.map((item) => item.idx))
    selectedIds.value = selectedIds.value.filter((idx) => alive.has(idx))
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '주문을 불러오지 못했습니다.'
    items.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  applyStatusQuery()
  applyKeywordQuery()
  load()
})

function applyKeywordQuery() {
  keyword.value = String(route.query.keyword ?? '').trim()
}

watch(
  () => route.query.status,
  () => {
    applyStatusQuery()
    clearSelection()
  },
)

watch(
  () => route.query.keyword,
  () => {
    applyKeywordQuery()
  },
)

watch(keyword, (value) => {
  const next = String(value || '').trim()
  const current = String(route.query.keyword ?? '').trim()
  if (next === current) return
  const query = { ...route.query }
  if (next) query.keyword = next
  else delete query.keyword
  router.replace({ query })
})

const tabs = computed(() => [
  { key: 'all' as const, label: '전체', count: items.value.length },
  { key: 'PAID' as const, label: '신규', count: counts.value.PAID ?? 0 },
  { key: 'READY' as const, label: '발송준비', count: counts.value.READY ?? 0 },
  { key: 'SHIPPING' as const, label: '배송중', count: counts.value.SHIPPING ?? 0 },
  { key: 'DELIVERED' as const, label: '배송완료', count: counts.value.DELIVERED ?? 0 },
  {
    key: 'CANCELED' as const,
    label: '취소',
    count: (counts.value.CANCELED ?? 0) + (counts.value.CANCEL_REQUEST ?? 0),
  },
])

const filtered = computed(() => {
  const query = keyword.value.toLowerCase()
  return items.value.filter((item) => {
    if (filter.value === 'CANCELED') {
      if (item.status !== 'CANCELED' && item.status !== 'CANCEL_REQUEST') return false
    } else if (filter.value !== 'all' && item.status !== filter.value) {
      return false
    }
    if (!inRange(item.paidAt || item.orderedAt)) return false
    if (!query) return true
    return (
      item.orderCode.toLowerCase().includes(query) ||
      item.buyerOrg.toLowerCase().includes(query) ||
      item.name.toLowerCase().includes(query) ||
      item.receiver.toLowerCase().includes(query) ||
      (item.poNumber || '').toLowerCase().includes(query)
    )
  })
})

const selectedSet = computed(() => new Set(selectedIds.value))

function isSelectable(item: SellerOrderItem) {
  return item.status === 'PAID' || canWriteInvoice(item)
}

const selectableFiltered = computed(() => filtered.value.filter(isSelectable))

const allSelectableChecked = computed(
  () =>
    selectableFiltered.value.length > 0 &&
    selectableFiltered.value.every((item) => selectedSet.value.has(item.idx)),
)

const someSelectableChecked = computed(() =>
  selectableFiltered.value.some((item) => selectedSet.value.has(item.idx)),
)

const selectedItems = computed(() =>
  items.value.filter((item) => selectedSet.value.has(item.idx)),
)

const bulkReadyTargets = computed(() =>
  selectedItems.value.filter((item) => item.status === 'PAID'),
)

const bulkShipTargets = computed(() =>
  selectedItems.value.filter((item) => canWriteInvoice(item)),
)

function setFilter(next: 'all' | MallOrderItemStatus) {
  filter.value = next
  const query = { ...route.query }
  if (next === 'all') {
    delete query.status
  } else {
    query.status = next.toLowerCase()
  }
  router.replace({ path: route.path, query })
}

function statusTone(status: MallOrderItemStatus): string {
  return STATUS_TONE[status] ?? 'sui-badge--gray'
}

function toggleSelect(idx: number) {
  if (selectedSet.value.has(idx)) {
    selectedIds.value = selectedIds.value.filter((id) => id !== idx)
  } else {
    selectedIds.value = [...selectedIds.value, idx]
  }
}

function toggleSelectAll(event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  const ids = selectableFiltered.value.map((item) => item.idx)
  if (checked) {
    selectedIds.value = [...new Set([...selectedIds.value, ...ids])]
  } else {
    const drop = new Set(ids)
    selectedIds.value = selectedIds.value.filter((id) => !drop.has(id))
  }
}

function clearSelection() {
  selectedIds.value = []
}

async function bulkConfirm() {
  if (working.value || !bulkReadyTargets.value.length) return
  const ok = await confirmDialog({
    title: '일괄 주문 확인',
    message: `${bulkReadyTargets.value.length}건을 발송준비로 바꿀까요?`,
    confirmLabel: '확인',
    tone: 'primary',
  })
  if (!ok) return

  working.value = true
  try {
    for (const item of bulkReadyTargets.value) {
      await updateSellerOrderStatus(item.idx, 'READY')
    }
    notify(`${bulkReadyTargets.value.length}건을 발송준비로 바꿨습니다.`)
    clearSelection()
    await load()
  } catch (error) {
    notify(error instanceof Error ? error.message : '일괄 주문 확인에 실패했습니다.')
  } finally {
    working.value = false
  }
}

function openBulkShip() {
  const rows = bulkShipTargets.value
  if (!rows.length) return
  bulkShipRows.value = rows
  bulkCourier.value = loadLastCourier()
  bulkPasteText.value = ''
  rows.forEach((row) => {
    bulkInvoices[row.idx] = row.invoice || ''
  })
  bulkShipOpen.value = true
}

function applyBulkPaste() {
  const lines = bulkPasteText.value
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
  if (!lines.length) {
    notify('붙여넣을 내용을 입력해 주세요.')
    return
  }
  let applied = 0
  for (const line of lines) {
    const parts = line
      .split(/[\t,]/)
      .map((part) => part.trim())
      .filter(Boolean)
    if (parts.length < 2) continue
    const orderCode = parts[0]
    const invoice = parts.slice(1).join('').trim()
    if (!orderCode || !invoice) continue
    const row = bulkShipRows.value.find((item) => item.orderCode === orderCode)
    if (!row) continue
    bulkInvoices[row.idx] = invoice
    applied += 1
  }
  if (!applied) {
    notify('일치하는 주문번호가 없습니다.')
    return
  }
  notify(`${applied}건 송장번호를 채웠습니다.`)
}

function printPickingList() {
  if (!selectedItems.value.length) return
  window.print()
}

async function confirmBulkShip() {
  if (working.value || !bulkShipRows.value.length) return

  const courier = bulkCourier.value
  const direct = isDirectCourierName(courier)
  if (!direct) {
    const missing = bulkShipRows.value.find((row) => !String(bulkInvoices[row.idx] || '').trim())
    if (missing) {
      notify('모든 행에 송장번호를 입력해 주세요. 직접배송은 생략할 수 있습니다.')
      return
    }
  }

  working.value = true
  try {
    for (const row of bulkShipRows.value) {
      const nextStatus = isNewShip(row) ? 'SHIPPING' : row.status
      await updateSellerOrderStatus(row.idx, nextStatus, {
        courier,
        invoice: String(bulkInvoices[row.idx] || '').trim(),
      })
    }
    saveLastCourier(courier)
    notify(`${bulkShipRows.value.length}건 송장을 저장했습니다.`)
    bulkShipOpen.value = false
    clearSelection()
    await load()
  } catch (error) {
    notify(error instanceof Error ? error.message : '일괄 발송에 실패했습니다.')
  } finally {
    working.value = false
  }
}

async function move(item: SellerOrderItem, status: MallOrderItemStatus) {
  const delivering = status === 'DELIVERED'
  const ok = await confirmDialog({
    title: delivering ? '배송완료' : '주문 상태 변경',
    message: delivering
      ? `${item.orderCode} 상품이 도착했습니까? 도착한 뒤에만 배송완료로 바꿔 주세요.`
      : `${item.orderCode} 주문을 '${MALL_ORDER_ITEM_STATUS_LABEL[status]}'으로 바꿀까요?`,
    detail: delivering
      ? '배송완료 후 7일이 지나면 구매가 자동 확정되고, 구매확정된 달 정산에 잡힙니다.'
      : undefined,
    confirmLabel: delivering ? '배송완료' : '변경',
    tone: 'primary',
  })
  if (!ok) return

  try {
    await updateSellerOrderStatus(item.idx, status)
    notify(
      delivering
        ? '배송완료로 바꿨습니다. 구매 기관이 확정하거나 7일이 지나면 정산에 반영됩니다.'
        : `'${MALL_ORDER_ITEM_STATUS_LABEL[status]}'으로 바꿨습니다.`,
    )
    await load()
  } catch (error) {
    notify(error instanceof Error ? error.message : '주문 상태를 바꾸지 못했습니다.')
  }
}

function openShip(item: SellerOrderItem) {
  shipTarget.value = item
  shipForm.courier = item.courier || loadLastCourier()
  shipForm.invoice = item.invoice || ''
}

function openExtraShip(item: SellerOrderItem) {
  extraShipTarget.value = item
  extraShipForm.courier = loadLastCourier()
  extraShipForm.invoice = ''
  extraShipForm.qty = Math.max(1, Math.min(item.qty, 1))
  extraShipForm.memo = '오발송·누락 재발송'
}

async function confirmExtraShip() {
  if (!extraShipTarget.value || working.value) return

  const courier = extraShipForm.courier
  const invoice = extraShipForm.invoice.trim()
  const direct = isDirectCourierName(courier)
  const qty = Math.max(1, Math.trunc(Number(extraShipForm.qty) || 1))
  const memo = extraShipForm.memo.trim() || '오발송·누락 재발송'

  if (!direct && !invoice) {
    notify('재발송 송장번호를 입력해 주세요. 직접배송은 생략할 수 있습니다.')
    return
  }
  if (!direct && isExistingWaybill(extraShipTarget.value, invoice)) {
    notify('이미 있는 송장입니다. 택배를 따로 보냈을 때만 다른 송장을 넣어 주세요.')
    return
  }
  if (qty > extraShipTarget.value.qty) {
    notify(`재발송 수량은 주문 수량(${extraShipTarget.value.qty})을 넘을 수 없습니다.`)
    return
  }

  const ok = await confirmDialog({
    title: '재발송 등록',
    message: `${extraShipTarget.value.orderCode} 주문에 재발송 송장을 추가할까요? 주문번호는 그대로입니다.`,
    detail: `${extraShipTarget.value.buyerOrg}\n${extraShipTarget.value.name}\n${courier}${
      invoice ? `\n송장 ${invoice}` : '\n송장 없음(직접배송)'
    }\n수량 ${qty}\n사유 ${memo}`,
    confirmLabel: '등록',
    tone: 'primary',
  })
  if (!ok) return

  working.value = true
  try {
    await createSellerExtraShipment(extraShipTarget.value.idx, {
      courier,
      invoice,
      qty,
      memo,
    })
    saveLastCourier(courier)
    notify('재발송 송장을 등록했습니다. 주문번호는 그대로입니다.')
    extraShipTarget.value = null
    await load()
  } catch (error) {
    notify(error instanceof Error ? error.message : '재발송 등록에 실패했습니다.')
  } finally {
    working.value = false
  }
}

async function confirmShip() {
  if (!shipTarget.value || working.value) return

  const courier = shipForm.courier
  const invoice = shipForm.invoice.trim()
  const direct = isDirectCourierName(courier)
  const shippingNew = isNewShip(shipTarget.value)

  if (!direct && !invoice) {
    notify('송장번호를 입력해 주세요. 직접배송은 생략할 수 있습니다.')
    return
  }

  const ok = await confirmDialog({
    title: shippingNew ? '발송 처리' : '송장 저장',
    message: shippingNew
      ? `${shipTarget.value.orderCode} 주문을 발송 처리할까요?`
      : `${shipTarget.value.orderCode} 송장을 저장할까요?`,
    detail: `${courier}${invoice ? `\n송장 ${invoice}` : '\n송장 없음(직접배송)'}${
      shippingNew ? '\n이후 진행은 송장으로 자동 조회됩니다.' : '\n주문 상태는 유지됩니다.'
    }`,
    confirmLabel: shippingNew ? '발송' : '저장',
    tone: 'primary',
  })
  if (!ok) return

  working.value = true

  try {
    const nextStatus = shippingNew ? 'SHIPPING' : shipTarget.value.status
    await updateSellerOrderStatus(shipTarget.value.idx, nextStatus, {
      courier,
      invoice,
    })
    saveLastCourier(courier)
    notify(
      shippingNew
        ? '발송 처리했습니다. 이후 진행은 송장으로 자동 조회됩니다.'
        : '송장을 저장했습니다.',
    )
    shipTarget.value = null
    await load()
  } catch (error) {
    notify(error instanceof Error ? error.message : '발송 처리에 실패했습니다.')
  } finally {
    working.value = false
  }
}

function orderAgeHours(item: SellerOrderItem): number | null {
  if (item.status !== 'PAID' && item.status !== 'READY') return null
  const raw = item.paidAt || item.orderedAt
  if (!raw) return null
  const at = new Date(raw).getTime()
  if (Number.isNaN(at)) return null
  return Math.max(0, (Date.now() - at) / 36e5)
}

function slaClass(item: SellerOrderItem): string {
  const hours = orderAgeHours(item)
  if (hours == null) return ''
  if (hours >= 48) return 'is-sla-alert'
  if (hours >= 24) return 'is-sla-warn'
  return ''
}

function slaLabel(item: SellerOrderItem): string {
  const hours = orderAgeHours(item)
  if (hours == null) return ''
  if (hours >= 48) return '발송 지연 48h+'
  if (hours >= 24) return '발송 주의 24h+'
  return ''
}

function formatDateTime(value: string | null): string {
  if (!value) return '-'
  const date = new Date(value)
  return `${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')} ${String(
    date.getHours(),
  ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

function downloadExcel() {
  const rows = filtered.value
  if (!rows.length) return

  const header = [
    '주문번호',
    '결제수단',
    '결제확인일시',
    '상품명',
    '옵션',
    '수량',
    '금액',
    '정산예정',
    '구매기관',
    '수령인',
    '연락처',
    '배송지',
    '발주번호',
    '상태',
    '택배사',
    '송장번호',
  ]
  const body = rows.map((item) =>
    [
      item.orderCode,
      mallPayMethodLabel(item),
      formatDateTime(item.paidAt),
      item.name || '',
      item.option || '',
      String(item.qty ?? ''),
      String(item.amount ?? ''),
      String(item.settlement ?? ''),
      item.buyerOrg || '',
      item.receiver || '',
      item.phone || '',
      item.address || '',
      item.poNumber || '',
      MALL_ORDER_ITEM_STATUS_LABEL[item.status] || item.status,
      item.courier || '',
      item.invoice || '',
    ]
      .map((cell) => csvEscape(cell))
      .join(','),
  )
  const csv = `\uFEFF${[header.join(','), ...body].join('\n')}`
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `판매주문_${new Date().toISOString().slice(0, 10)}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _cache[19] || (_cache[19] = _createTextVNode(" 결제 확인된 주문 ", -1)),
        _createElementVNode("em", null, _toDisplayString(items.value.length) + "건", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.key,
            type: "button",
            class: _normalizeClass(["slive__tab", { 'is-active': filter.value === tab.key }]),
            onClick: ($event: any) => (setFilter(tab.key))
          }, [
            _createTextVNode(_toDisplayString(tab.label), 1),
            (tab.count)
              ? (_openBlock(), _createElementBlock("em", _hoisted_6, _toDisplayString(tab.count), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "sui-btn sui-btn--sm",
        "data-tour": "seller-orders-export",
        disabled: !filtered.value.length,
        onClick: downloadExcel
      }, [
        _createVNode(AppIcon, {
          icon: "mdi-download",
          size: 15
        }),
        _cache[20] || (_cache[20] = _createTextVNode(" CSV ", -1))
      ], 8, _hoisted_7),
      _createElementVNode("button", {
        type: "button",
        class: "sui-btn sui-btn--sm",
        disabled: loading.value,
        onClick: load
      }, [
        _createVNode(AppIcon, {
          icon: "mdi-refresh",
          size: 15
        }),
        _cache[21] || (_cache[21] = _createTextVNode(" 새로고침 ", -1))
      ], 8, _hoisted_8)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.key,
            type: "button",
            class: _normalizeClass(["sui-btn sui-btn--sm", { 'is-active': _unref(preset) === item.key }]),
            onClick: ($event: any) => (_unref(applyPreset)(item.key))
          }, _toDisplayString(item.label), 11, _hoisted_11))
        }), 128))
      ]),
      _createElementVNode("label", _hoisted_12, [
        _cache[22] || (_cache[22] = _createElementVNode("span", null, "시작", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fromDate) ? (fromDate).value = $event : null)),
          type: "date",
          class: "sui-input",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onManualDateChange) && _unref(onManualDateChange)(...args)))
        }, null, 544), [
          [_vModelText, _unref(fromDate)]
        ])
      ]),
      _createElementVNode("label", _hoisted_13, [
        _cache[23] || (_cache[23] = _createElementVNode("span", null, "종료", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(toDate) ? (toDate).value = $event : null)),
          type: "date",
          class: "sui-input",
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onManualDateChange) && _unref(onManualDateChange)(...args)))
        }, null, 544), [
          [_vModelText, _unref(toDate)]
        ])
      ]),
      _createElementVNode("label", _hoisted_14, [
        _createVNode(AppIcon, {
          icon: "mdi-magnify",
          size: 17
        }),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((keyword).value = $event)),
          type: "search",
          placeholder: "주문번호 · 기관 · 상품 · 수령인"
        }, null, 512), [
          [
            _vModelText,
            keyword.value,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    _cache[48] || (_cache[48] = _createElementVNode("p", {
      class: "slive__hint no-print",
      "data-tour": "seller-orders-deliver"
    }, " 신규 주문은 먼저 「주문 확인」을 눌러 주세요. 확인한 뒤에 발송 처리·송장을 넣을 수 있습니다. 택배 발송은 송장으로 진행이 자동 조회되고 도착 시 배송완료됩니다. ", -1)),
    _createElementVNode("aside", _hoisted_15, [
      _createVNode(AppIcon, {
        icon: "mdi-alert-circle-outline",
        size: 18
      }),
      _cache[24] || (_cache[24] = _createElementVNode("div", null, [
        _createElementVNode("strong", null, "직접배송은 「배송완료」를 반드시 수동으로 눌러 주세요."),
        _createElementVNode("span", null, " 자동 조회가 없어 도착 후에도 직접 완료 처리해야 정산에 잡힙니다. 배송중 목록에서 「배송완료」 버튼으로 처리합니다. ")
      ], -1))
    ]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
          _createVNode(AppIcon, {
            icon: "mdi-alert-outline",
            size: 16
          }),
          _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
        ]))
      : _createCommentVNode("", true),
    (selectedIds.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("span", null, _toDisplayString(selectedIds.value.length) + "건 선택", 1),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn sui-btn--sm",
            disabled: working.value || !bulkReadyTargets.value.length,
            onClick: bulkConfirm
          }, " 주문 확인(READY) ", 8, _hoisted_18),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn sui-btn--sm sui-btn--primary",
            disabled: working.value || !bulkShipTargets.value.length,
            onClick: openBulkShip
          }, " 일괄 발송 ", 8, _hoisted_19),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn sui-btn--sm",
            "data-tour": "seller-orders-picking",
            disabled: !selectedItems.value.length,
            onClick: printPickingList
          }, " 피킹리스트 인쇄 ", 8, _hoisted_20),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn sui-btn--sm sui-btn--ghost",
            onClick: clearSelection
          }, " 선택 해제 ")
        ]))
      : _createCommentVNode("", true),
    (selectedItems.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _cache[26] || (_cache[26] = _createElementVNode("h3", null, "피킹리스트", -1)),
          _createElementVNode("p", null, _toDisplayString(_unref(todayLabel)) + " · " + _toDisplayString(selectedItems.value.length) + "건", 1),
          _createElementVNode("table", null, [
            _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "주문번호"),
                _createElementVNode("th", null, "상품"),
                _createElementVNode("th", null, "수량"),
                _createElementVNode("th", null, "수령인"),
                _createElementVNode("th", null, "배송지")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.idx
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.orderCode) + " · " + _toDisplayString(_unref(mallPayMethodLabel)(item)), 1),
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                    (item.option)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString(item.option), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.qty), 1),
                  _createElementVNode("td", null, _toDisplayString(item.receiver) + " · " + _toDisplayString(item.phone), 1),
                  _createElementVNode("td", null, _toDisplayString(item.address), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (filtered.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_24, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: allSelectableChecked.value,
                    ".indeterminate": someSelectableChecked.value && !allSelectableChecked.value,
                    "aria-label": "선택 가능한 항목 전체",
                    onChange: toggleSelectAll
                  }, null, 40, _hoisted_25)
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("th", null, "주문번호 · 결제확인", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("th", null, "상품", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("th", null, "구매 기관 · 배송지", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("th", { class: "is-num" }, "수량 · 금액", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("th", { class: "is-num" }, "정산 예정", -1)),
                _cache[32] || (_cache[32] = _createElementVNode("th", { class: "is-center" }, "상태", -1)),
                _cache[33] || (_cache[33] = _createElementVNode("th", { class: "is-center" }, "처리", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.idx,
                  class: _normalizeClass(["slive__row", [
              slaClass(item),
              {
                'is-selected': selectedSet.value.has(item.idx),
                'is-focus': isKeywordFocus(item),
              },
            ]])
                }, [
                  _createElementVNode("td", _hoisted_26, [
                    (isSelectable(item))
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          checked: selectedSet.value.has(item.idx),
                          "aria-label": `${item.orderCode} 선택`,
                          onChange: ($event: any) => (toggleSelect(item.idx))
                        }, null, 40, _hoisted_27))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.orderCode), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["slive__pay", { 'is-card': item.payMethod === 'TOSS' }])
                    }, _toDisplayString(_unref(mallPayMethodLabel)(item)), 3),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(formatDateTime(item.paidAt)), 1),
                    (isKeywordFocus(item))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "알림에서 연 주문"))
                      : _createCommentVNode("", true),
                    ((item.qnaOpenCount || 0) > 0)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          class: "slive__qna-chip",
                          to: {
                  path: '/seller/reviews',
                  query: { tab: 'inquiry', filter: 'open', keyword: item.orderCode },
                },
                          title: `${item.orderCode} 주문의 미답변 상품문의 ${item.qnaOpenCount}건`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(AppIcon, {
                              icon: "mdi-comment-question-outline",
                              size: 12
                            }),
                            _createTextVNode(" 문의 " + _toDisplayString(item.qnaOpenCount), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_31, [
                      (item.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "sui-prod__img",
                            src: item.image,
                            alt: item.name,
                            loading: "lazy"
                          }, null, 8, _hoisted_32))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(item.name), 1),
                        (item.option)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, "옵션 · " + _toDisplayString(item.option), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(item.buyerOrg), 1),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(item.receiver) + " · " + _toDisplayString(item.phone), 1),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(item.address), 1),
                    (item.memo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "요청 · " + _toDisplayString(item.memo), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(formatWon)(item.amount)) + "원", 1),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(formatWon)(item.price)) + "원 × " + _toDisplayString(item.qty), 1)
                  ]),
                  _createElementVNode("td", _hoisted_42, [
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(formatWon)(item.settlement)) + "원", 1),
                    _createElementVNode("span", _hoisted_44, "내 마진 " + _toDisplayString(_unref(formatWon)(item.sellerMargin)) + "원", 1)
                  ]),
                  _createElementVNode("td", _hoisted_45, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["sui-badge", statusTone(item.status)])
                    }, _toDisplayString(_unref(MALL_ORDER_ITEM_STATUS_LABEL)[item.status]), 3),
                    (slaLabel(item))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["slive__sla", slaClass(item)])
                        }, _toDisplayString(slaLabel(item)), 3))
                      : _createCommentVNode("", true),
                    (item.invoice || item.shipments?.length)
                      ? (_openBlock(), _createBlock(MallShipmentLedger, {
                          key: 1,
                          size: "compact",
                          item: item,
                          onTrack: ($event: any) => (openItemShipment(item, $event))
                        }, null, 8, ["item", "onTrack"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass(["is-center", { 'is-confirm': item.status === 'PAID' }])
                  }, [
                    _createElementVNode("div", _hoisted_46, [
                      (item.status === 'PAID')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "sui-btn sui-btn--primary slive__confirm",
                            "data-tour": "seller-orders-confirm",
                            onClick: ($event: any) => (move(item, 'READY'))
                          }, " 주문 확인 ", 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      (item.status === 'PAID')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, " 확인해야 발송할 수 있습니다 "))
                        : _createCommentVNode("", true),
                      (canWriteInvoice(item))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: _normalizeClass(["sui-btn sui-btn--sm", { 'sui-btn--primary': isNewShip(item) }]),
                            onClick: ($event: any) => (openShip(item))
                          }, _toDisplayString(shipActionLabel(item)), 11, _hoisted_49))
                        : _createCommentVNode("", true),
                      (canExtraShip(item))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "sui-btn sui-btn--sm",
                            "data-tour": "seller-orders-extra-ship",
                            title: "오발송·누락으로 택배를 한 번 더 보냈을 때. 주문번호는 그대로입니다.",
                            onClick: ($event: any) => (openExtraShip(item))
                          }, " 재발송 등록 ", 8, _hoisted_50))
                        : _createCommentVNode("", true),
                      (item.invoice)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            class: "sui-btn sui-btn--sm",
                            "data-tour": "seller-orders-tracking",
                            onClick: ($event: any) => (openTracking(item))
                          }, " 배송조회 ", 8, _hoisted_51))
                        : _createCommentVNode("", true),
                      (item.status === 'SHIPPING' && isDirectShip(item))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 5,
                            type: "button",
                            class: "sui-btn sui-btn--sm sui-btn--primary",
                            onClick: ($event: any) => (move(item, 'DELIVERED'))
                          }, " 배송완료 ", 8, _hoisted_52))
                        : _createCommentVNode("", true),
                      (item.status === 'DELIVERED')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(item.deliveredAt ? _unref(autoConfirmLabel)(item.deliveredAt) : '구매확정 대기'), 1))
                        : (item.status === 'DONE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, " 처리 완료 "))
                          : _createCommentVNode("", true)
                    ])
                  ], 2)
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createVNode(AppIcon, {
            icon: "mdi-package-variant-closed",
            size: 30
          }),
          _createElementVNode("p", null, _toDisplayString(loading.value
            ? '주문을 불러오는 중입니다…'
            : '조건에 맞는 주문이 없습니다. 결제가 확인된 주문만 여기에 표시됩니다.'), 1)
        ])),
    (shipTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "slive__modal no-print",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (shipTarget.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("h3", null, _toDisplayString(shipDialogTitle(shipTarget.value)), 1),
            _createElementVNode("p", _hoisted_57, [
              _createElementVNode("strong", null, _toDisplayString(shipTarget.value.orderCode), 1),
              _createTextVNode(" · " + _toDisplayString(shipTarget.value.buyerOrg) + " · " + _toDisplayString(shipTarget.value.name) + " · " + _toDisplayString(shipTarget.value.qty) + "개 ", 1)
            ]),
            _createElementVNode("label", _hoisted_58, [
              _cache[34] || (_cache[34] = _createElementVNode("span", null, "택배사", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shipForm.courier) = $event)),
                class: "sui-select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COURIERS), (name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: name,
                    value: name
                  }, _toDisplayString(name), 9, _hoisted_59))
                }), 128))
              ], 512), [
                [_vModelSelect, shipForm.courier]
              ])
            ]),
            _createElementVNode("label", _hoisted_60, [
              _createElementVNode("span", null, "송장번호" + _toDisplayString(isDirectCourierName(shipForm.courier) ? ' (직접배송은 생략 가능)' : ''), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((shipForm.invoice) = $event)),
                class: "sui-input",
                placeholder: "숫자만 입력"
              }, null, 512), [
                [
                  _vModelText,
                  shipForm.invoice,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("p", _hoisted_61, [
              (isDirectCourierName(shipForm.courier))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[35] || (_cache[35] = _createElementVNode("strong", { class: "slive__dialog-warn" }, "직접배송:", -1)),
                    _cache[36] || (_cache[36] = _createTextVNode(" 발송 후 배송중으로 바뀝니다. 상품이 도착하면 주문 목록에서 ", -1)),
                    _cache[37] || (_cache[37] = _createElementVNode("strong", null, "「배송완료」를 직접 눌러야", -1)),
                    _cache[38] || (_cache[38] = _createTextVNode(" 합니다. 자동 완료되지 않습니다. ", -1))
                  ], 64))
                : (isNewShip(shipTarget.value))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" 발송하면 배송중으로 바뀝니다. 이후 진행은 송장으로 자동 조회되고, 도착하면 배송완료로 바뀝니다. ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" 송장·택배사만 저장합니다. 주문 상태는 바꾸지 않습니다. ")
                    ], 64))
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (shipTarget.value = null))
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: working.value,
                onClick: confirmShip
              }, _toDisplayString(isNewShip(shipTarget.value) ? '발송 처리' : '송장 저장'), 9, _hoisted_63)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (extraShipTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "slive__modal no-print",
          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (extraShipTarget.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_64, [
            _cache[42] || (_cache[42] = _createElementVNode("h3", null, "재발송 등록", -1)),
            _createElementVNode("p", _hoisted_65, [
              _createElementVNode("strong", null, _toDisplayString(extraShipTarget.value.orderCode), 1),
              _createTextVNode(" · " + _toDisplayString(extraShipTarget.value.buyerOrg) + " · " + _toDisplayString(extraShipTarget.value.name), 1)
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("p", { class: "slive__dialog-note" }, " 주문번호는 바뀌지 않습니다. 오발송·누락으로 택배를 한 번 더 보냈을 때, 본발송과 다른 송장만 추가합니다. 카톤 단위는 주문 수량일 뿐 배송을 나누지 않습니다. ", -1)),
            _createElementVNode("label", _hoisted_66, [
              _cache[39] || (_cache[39] = _createElementVNode("span", null, "택배사", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((extraShipForm.courier) = $event)),
                class: "sui-select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COURIERS), (name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: name,
                    value: name
                  }, _toDisplayString(name), 9, _hoisted_67))
                }), 128))
              ], 512), [
                [_vModelSelect, extraShipForm.courier]
              ])
            ]),
            _createElementVNode("label", _hoisted_68, [
              _createElementVNode("span", null, "재발송 송장번호" + _toDisplayString(isDirectCourierName(extraShipForm.courier) ? ' (직접배송은 생략 가능)' : ''), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((extraShipForm.invoice) = $event)),
                class: "sui-input",
                placeholder: "숫자만 입력"
              }, null, 512), [
                [
                  _vModelText,
                  extraShipForm.invoice,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_69, [
              _cache[40] || (_cache[40] = _createElementVNode("span", null, "이번에 보내는 수량", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((extraShipForm.qty) = $event)),
                class: "sui-input",
                type: "number",
                min: "1",
                max: extraShipTarget.value.qty
              }, null, 8, _hoisted_70), [
                [
                  _vModelText,
                  extraShipForm.qty,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_71, [
              _cache[41] || (_cache[41] = _createElementVNode("span", null, "사유", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((extraShipForm.memo) = $event)),
                class: "sui-input",
                maxlength: "120",
                placeholder: "예: 오발송 보충"
              }, null, 512), [
                [
                  _vModelText,
                  extraShipForm.memo,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (extraShipTarget.value = null))
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: working.value,
                onClick: confirmExtraShip
              }, " 재발송 등록 ", 8, _hoisted_73)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (bulkShipOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "slive__modal no-print",
          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (bulkShipOpen.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_74, [
            _cache[46] || (_cache[46] = _createElementVNode("h3", null, "일괄 발송", -1)),
            _createElementVNode("p", _hoisted_75, "선택한 " + _toDisplayString(bulkShipRows.value.length) + "건에 송장을 입력합니다.", 1),
            _cache[47] || (_cache[47] = _createElementVNode("p", { class: "slive__dialog-note" }, " 발송준비 건은 배송중으로 바뀌고, 이미 발송된 건은 송장만 갱신합니다. 직접배송은 송장 없이 저장할 수 있습니다. 아직 주문 확인 전인 신규는 일괄 발송할 수 없습니다. ", -1)),
            _createElementVNode("label", _hoisted_76, [
              _cache[44] || (_cache[44] = _createElementVNode("span", null, "택배사 (공통)", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((bulkCourier).value = $event)),
                class: "sui-select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COURIERS), (name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: name,
                    value: name
                  }, _toDisplayString(name), 9, _hoisted_77))
                }), 128))
              ], 512), [
                [_vModelSelect, bulkCourier.value]
              ])
            ]),
            _createElementVNode("label", _hoisted_78, [
              _cache[45] || (_cache[45] = _createElementVNode("span", null, "송장 붙여넣기 (주문번호 + 송장)", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((bulkPasteText).value = $event)),
                class: "sui-input",
                rows: "3",
                placeholder: "MO-A7X4K2P9\t1234567890"
              }, null, 512), [
                [_vModelText, bulkPasteText.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--sm",
                onClick: applyBulkPaste
              }, " 붙여넣기 적용 ")
            ]),
            _createElementVNode("div", _hoisted_79, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkShipRows.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.idx,
                  class: "slive__bulk-ship-row"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(row.orderCode), 1),
                    _createElementVNode("span", null, _toDisplayString(row.name) + " · " + _toDisplayString(row.qty) + "개", 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((bulkInvoices[row.idx]) = $event),
                    class: "sui-input",
                    placeholder: "송장번호"
                  }, null, 8, _hoisted_80), [
                    [
                      _vModelText,
                      bulkInvoices[row.idx],
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (bulkShipOpen.value = false))
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: working.value,
                onClick: confirmBulkShip
              }, " 일괄 발송 처리 ", 8, _hoisted_82)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (trackTarget.value)
      ? (_openBlock(), _createBlock(MallTrackingModal, {
          key: 8,
          "item-idx": trackTarget.value.idx,
          courier: trackTarget.value.courier,
          invoice: trackTarget.value.invoice,
          "product-name": trackTarget.value.name,
          "order-code": trackTarget.value.orderCode,
          onClose: onCloseTracking
        }, null, 8, ["item-idx", "courier", "invoice", "product-name", "order-code"]))
      : _createCommentVNode("", true)
  ]))
}
}

})